<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte de Importaciones UPS</v-toolbar-title>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="desde" type="date" clearable label="Desde"></v-text-field><v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="hasta" type="date" clearable label="Hasta"></v-text-field><v-divider class="mx-4" vertical />
                 <v-btn dark dense @click="getDatosReporte()" outlined exact > Generar <v-icon>mdi-file</v-icon></v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical></v-divider>
                    <v-tooltip bottom color="#96298A">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" @click="exportToExcel()">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
              </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
              <v-data-table
              :items="datosReporte"
              :headers="headersReporte"
              :search="searcher"
              >
              <!--template v-slot:item.created_at="{ item }">
                  {{formatDate(item.created_at)}}
              </template-->
              </v-data-table>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data(){
    return{
        desde: null,
        hasta: null,
        isCliente: false,
        searcher: '',
        datosReporte: [],
        headersReporte:[
            { text: "Fecha Solicitud", value: "fecha_proveedor", sortable: false },
            { text: "AWB Inexpress", value: "guia_interna", sortable: false },
            { text: "AWB Operador", value: "guia_proveedor", sortable: false },
            { text: "Operador", value: "proveedor", sortable: false },
            { text: "País Origen", value: "pais_e", sortable: false },
            { text: "Empresa Receiver", value: "empresa_c", sortable: false },
            { text: "No Piezas", value: "piezas", sortable: false },
            { text: "Peso", value: "peso", sortable: false },
            { text: "Valor", value: "valor", sortable: false },
            { text: "Moneda", value: "moneda", sortable: false },
            { text: "Régimen", value: "regimen", sortable: false },
            { text: "Arribo En", value: "arribo_en", sortable: false },
        ],
    }
},
methods:{
    getDatosReporte: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reporteimportacionesups',{
            desde: this.desde,
            hasta: this.hasta
            }).then((result) => {
                this.datosReporte = result
            });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.datosReporte.map(rec => {
            return{
                'Fecha Solicitud' :  new Date (rec.fecha_proveedor),
                "AWB Inexpress": rec.guia_interna,
                "AWB Operador": rec.guia_proveedor,
                "Operador": rec.proveedor,
                "País Origen": rec.pais_e,
                "Empresa Receiver": rec.empresa_c,
                "No Piezas": rec.piezas,
                "Peso": rec.peso,
                "Valor": rec.valor,
                "Moneda": rec.moneda,
                "Régimen": rec.regimen,
                "Arribo En": rec.arribo_en,
            }
        });
        let data = XLSX.utils.json_to_sheet(newJson)
        const workbook = XLSX.utils.book_new()
        const filename = 'Reporte de Seguros';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
mounted: function(){
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
    //this.getDatosReporte();
}
}
</script>
